export default "__VITE_ASSET__61e0503e__"